import {SvgIcon, SvgIconProps} from '@mui/material';
import React from 'react';
// @ts-ignore
import {ReactComponent as Warning} from '../../../assets/images/icons/warningIcon.svg';

const WarningIcon: React.FC<SvgIconProps> = (props: SvgIconProps) => {
  return <SvgIcon {...props} component={Warning} viewBox='0 0 24 24' />;
};

export default WarningIcon;
